<template>
    <pendo-input-number
        class="number-input"
        :class="`${field}-number-input`"
        :value="value"
        :invalid="(checkValidRule && !valid) || invalid"
        :labels="labels"
        :disabled="readOnly"
        :min="min"
        :max="max"
        @input="onInputChange"
        @blur="onBlur"
        @change="onNumberChange" />
</template>

<script>
import { PendoInputNumber } from '@pendo/components';
import isNumber from 'lodash/isNumber';

export default {
    name: 'NumberInput',
    components: {
        PendoInputNumber,
    },
    inject: {
        setPendingChanges: {
            default: '',
        },
    },
    props: {
        // eslint-disable-next-line vue/require-default-prop
        value: {
            type: null,
        },
        field: {
            type: String,
            default: 'value',
        },
        labels: {
            type: Object,
            default: () => ({}),
        },
        min: {
            type: Number,
            default: 0,
        },
        max: {
            type: Number,
            default: Infinity,
        },
        invalid: {
            type: Boolean,
            default: false,
        },
        checkValidRule: {
            type: Boolean,
            default: false,
        },
        readOnly: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['input'],
    data () {
        return {
            pendingChanges: false,
        };
    },
    computed: {
        valid () {
            if (this.value < this.min) {
                return false;
            }

            if (this.value > this.max) {
                return false;
            }

            return isNumber(this.value);
        },
    },
    created () {
        const value = isNumber(this.value) ? this.value : 1;
        this.onNumberChange(value);
    },
    methods: {
        onNumberChange (value) {
            if (value == null) {
                value = 0;
            }
            this.$emit('input', { field: this.field, value });
            this._setPendingChanges(false);
        },
        onInputChange () {
            this._setPendingChanges(true);
        },
        onBlur () {
            this._setPendingChanges(false);
        },
        _setPendingChanges (pendingChanges) {
            if (this.pendingChanges === pendingChanges) return;
            this.pendingChanges = pendingChanges;
            if (this.setPendingChanges) this.setPendingChanges(pendingChanges, 'number-input');
        },
    },
};
</script>
